module.exports = __webpack_public_path__ + "static/connectionNo-2c98c2579c2e57cbed5b5717914173ec.png";